import React, { useState, Fragment } from 'react';
import { Container, Row, Col, Form, Modal, Button, Card, ListGroup, Badge } from 'react-bootstrap';
import Footer from 'layout/footer';
import Header from 'layout/header';
import './contactus.css';
import { loadFromLocalStorage } from 'utils/LocalStorageUtils';
import { useEffect } from "react";
import { Link } from 'react-router-dom';
import { apiCall } from 'utils/httpClient';
import apiEndPoint from 'utils/apiEndPoint';
import { successMessage } from 'utils/httpClient';

function ContactUs() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    message: ''
  });
  const [languageData, setLanguageData] = useState(null);
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])
  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const [userData, setUserData] = useState(null);
  useEffect(() => {
    const authData = loadFromLocalStorage("AUTH_DATA");
    if (authData?.token) {
      setUserData(authData?.userDetail)
    }
  }, []);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Here you can handle the form submission, e.g., send data to an API or email
    formData.user_id = userData?._id

    const { data } = await apiCall("post", apiEndPoint.CONTACTUSFORUSER, formData);
    if (data.status === 200) {
      successMessage(data.message)
      setFormData({ firstName: '', lastName: '', email: '', mobile: '', message: '' })
    }
  };
  return (
    <Fragment>
      <div className="services-section mt-5">
        <div className="container text-center">
          <h3 className="animate__animated animate__bounce" style={{ fontFamily: 'quicksand', fontWeight: 600, textAlign: 'center', margin: 'auto' }}>
            {languageData?.contacus}
          </h3>
          <br />
          <p style={{ fontSize: 16, fontWeight: 600, maxWidth: 800, margin: 'auto', color: '#444' }}>
            {languageData?.contacdescp}
          </p>
        </div>
      </div>
      <br /><br />
      <Container>
        <section className="text-center-sm">
          <div className="container">
            <div className="row" style={{ alignItems: 'center' }}>
              <div className="col-lg-6">
                <h2 style={{ fontFamily: 'quicksand', fontWeight: 600 }}> {languageData?.get24suppo} </h2> <br />
                <p style={{ fontSize: 17, fontWeight: 500, width: '100%' }}>
                  {languageData?.youcanaskcontac}
                </p>
                <br />
                <span style={{ display: 'block', border: '1px solid #ff671f', maxWidth: '60%' }}></span>
              </div>
              <div className="col-lg-6">
                <div className="text-center">
                  <Link to='/privacypolicies' style={{ color: 'inherit' }}>
                    <button style={{ marginTop: 20, marginBottom: 20, fontSize: 14 }}
                      className="btn play-btn"
                    >
                      {languageData?.helpCenter}  <i class="fa fa-chevron-circle-right ml-1" aria-hidden="true"></i>
                    </button>{" "}
                  </Link>
                </div>
              </div>
            </div> <br /> <br />
            <div className="row" style={{ alignItems: 'center' }}>
              <div className="col-lg-6">
                <h2 style={{ fontFamily: 'quicksand', fontWeight: 600 }}>{languageData?.email}</h2> <br />
                <p style={{ fontSize: 17, fontWeight: 500, width: '100%' }}>
                  {languageData?.prefermailreac1} <span style={{ color: '#ff671f' }}>support@mydigitalindia.app</span>  {languageData?.prefermailreac2}
                </p>
                <br />
                <span style={{ display: 'block', border: '1px solid #ff671f', maxWidth: '60%' }}></span>
              </div>
            </div> <br /> <br />
            <div className="row" style={{ alignItems: 'center' }}>
              <div className="col-lg-6">
                <h2 style={{ fontFamily: 'quicksand', fontWeight: 600 }}> {languageData?.livchat} </h2> <br />
                <p style={{ fontSize: 17, fontWeight: 500, width: '100%' }}>
                  {languageData?.connecwithus1}
                  <span style={{ color: '#ff671f' }}> 10:00am - 6:00pm (IST) </span>{languageData?.connecwithus2} </p>
                <br />
                <span style={{ display: 'block', border: '1px solid #ff671f', maxWidth: '60%' }}></span>
              </div>
              <div className="col-lg-6">
                <div className="text-center">
                  <button style={{ marginTop: 20, marginBottom: 20, fontSize: 14 }}
                    className="btn play-btn"
                  >
                    {languageData?.livchat} <i class="fa fa-chevron-circle-right ml-1" aria-hidden="true"></i>
                  </button>{" "}
                </div>
              </div>
            </div> <br /> <br />
            <div style={{ padding: 40, borderRadius: 30, background: '#ff966a' }}>
              <Row className="justify-content-center">
                <Col md={6}>
                  <h2>{languageData?.contacform}</h2> <br />
                  <p style={{ fontSize: 17, fontWeight: 500, width: '100%' }}>
                    {languageData?.fillouteasy}
                  </p>
                </Col>
                <Col md={6}>
                  <Form onSubmit={handleSubmit}>
                    <div className="d-flex" style={{ justifyContent: 'space-between' }}>
                      <Form.Group controlId="firstName" style={{ width: '48%' }}>
                        <Form.Label>{languageData?.fistnam}</Form.Label>
                        <Form.Control style={{ background: 'transparent', border: '1px solid #000', placeholder: 'black' }}
                          type="text"
                          placeholder="Enter your first name"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                      <Form.Group controlId="lastName" style={{ width: '48%' }}>
                        <Form.Label>{languageData?.lasnam}</Form.Label>
                        <Form.Control style={{ background: 'transparent', border: '1px solid #000', placeholder: 'black' }}
                          type="text"
                          placeholder="Enter your last name"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>

                    <Form.Group controlId="email" className='mt-2'>
                      <Form.Label>{languageData?.email}</Form.Label>
                      <Form.Control style={{ background: 'transparent', border: '1px solid #000', placeholder: 'black' }}
                        type="email"
                        placeholder="Enter your email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>

                    <Form.Group controlId="mobile" className='mt-2'>
                      <Form.Label>{languageData?.mobinumber}</Form.Label>
                      <Form.Control style={{ background: 'transparent', border: '1px solid #000', placeholder: 'black' }}
                        type="text"
                        placeholder="Enter your mobile number"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>

                    <Form.Group controlId="message" className='mt-2'>
                      <Form.Label>{languageData?.messaGe}</Form.Label>
                      <Form.Control style={{ background: 'transparent', border: '1px solid #000', placeholder: 'black' }}
                        as="textarea"
                        rows={4}
                        placeholder="Enter your message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>

                    <button style={{ marginTop: 20, marginBottom: 20, fontSize: 14 }}
                      className="btn play-btn"
                    >
                      {languageData?.submit} <i class="fa fa-chevron-circle-right ml-1" aria-hidden="true"></i>
                    </button>{" "}
                  </Form>
                </Col>
              </Row>
            </div> <br /> <br />
            <div className="row" style={{ alignItems: 'center' }}>
              <div className="col-lg-6">
                <h2>{languageData?.folowUs}</h2> <br />
                <p style={{ fontSize: 17, fontWeight: 500, width: '100%' }}>
                  {languageData?.joinurvibrantcomm}
                </p>
                <br />
                <span style={{ display: 'block', border: '1px solid #ff671f', maxWidth: '60%' }}></span>
              </div>
              <div className="col-lg-6">
                <Link to="https://www.facebook.com/YourProfile">
                  <img style={{ cursor: 'pointer', borderRadius: 15 }} width={50} src="https://cdn-icons-png.flaticon.com/256/124/124010.png" alt="" />
                </Link>
                <Link to="https://www.instagram.com/YourProfile">
                  <img style={{ cursor: 'pointer', borderRadius: 15, marginLeft: 20 }} width={50} src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="" />
                </Link>
                <Link to="https://www.youtube.com/YourProfile">
                  <img style={{ cursor: 'pointer', borderRadius: 15, marginLeft: 20, border: '1px solid #eee' }} width={50} src="https://img.freepik.com/premium-vector/3d-vector-youtube-logo_1016288-184.jpg?semt=ais_hybrid" alt="" />
                </Link>
              </div>
            </div> <br />
          </div>
        </section>
      </Container>
    </Fragment>
  );
}

export default ContactUs;